module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Dialog', {
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.handleCloseDialog()
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col w-full h-full"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center pl-5 pr-4 pt-3.5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2 font-manrope cursor-default"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": ("/static/roundtable_icons/" + ('written') + "_icon_color.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Written RoundTable")])]), _vm._v(" "), (_vm.isLoading === false && _vm.course) ? _c('button', {
    staticClass: "flex items-center space-x-2.5 font-manrope text-gray-800"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2.5 hover:underline"
  }, [_c('img', {
    staticClass: "w-3 -mt-0.5",
    attrs: {
      "src": "/static/roundtable_icons/courses_icon.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.course.title))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [(_vm.isSaving) ? _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('div', {
    staticClass: "flex items-center justify-center"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/cloud-upload.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-manrope text-xs text-gray-800"
  }, [_vm._v("Saving Changes...")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "w-7 h-7 focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark rounded-full cursor-pointer bg-gray-50 hover:bg-gray-100 text-base flex items-center justify-center hover:text-gray-800 text-gray-700",
    on: {
      "click": function($event) {
        return _vm.handleCloseDialog()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between space-x-5 items-center px-5 relative w-full mb-2.5 mt-2.5"
  }, [_c('div', {
    staticClass: "flex-grow"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "w-full text-3xl font-manrope font-bold text-gray-800 border-none bg-white py-1 outline-none",
    attrs: {
      "placeholder": "Enter a title..."
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "flex sample items-center space-x-2 disabled:opacity-50 bg-primary hover:bg-primary-dark rounded-md border border-solid border-primary text-white py-1.5 px-4",
    attrs: {
      "disabled": _vm.isSaveButtonDisabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveRoundTable()
      }
    }
  }, [(_vm.isSaving === true) ? _c('div', {
    staticClass: "loader -ml-1"
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.isSaving === true ? 'Saving...' : 'Save'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between w-full h-11 focus-within:border-pinky border-b border-solid border-gray-200 pl-4 pr-5"
  }, [_c('div', {
    staticClass: "flex items-center w-full font-manrope"
  }, [_c('div', {
    staticClass: "w-14 h-14 -ml-3"
  }, [_c('iframe', {
    attrs: {
      "src": "https://lottie.host/embed/874b8bf3-ca7e-46f3-9c81-cf94974ad30b/Djg5qZsQK9.lottie",
      "width": "100%",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.revise.input),
      expression: "revise.input"
    }],
    ref: "genieRevise",
    staticClass: "w-full disabled:bg-white border-none",
    attrs: {
      "placeholder": "How can I help you make this discussion prompt better?"
    },
    domProps: {
      "value": (_vm.revise.input)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleReviseWrittenPrompt()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.revise, "input", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-5"
  }, [_c('pl-menu', {
    attrs: {
      "direction": "right",
      "menuSize": 3
    }
  }, [_c('button', {
    staticClass: "flex items-center space-x-2.5 font-manrope text-gray-800",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('span', [_vm._v(_vm._s(_vm.revise.mode))]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid fa-chevron-down text-xs text-gray-600 hover:text-gray-800"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "flex flex-col space-y-1.5 rounded-lg mt-0.5 text-sm shadow-sm px-1 pt-0.5 pb-1 font-manrope max-h-96",
    attrs: {
      "menu-content": ""
    }
  }, [_c('li', {
    staticClass: "flex items-center space-x-1 justify-between hover:bg-gray-100 px-2.5 py-1 cursor-pointer rounded-md"
  }, [_c('span', [_vm._v("Prompt")]), _vm._v(" "), (_vm.revise.mode === 'Prompt') ? _c('i', {
    staticClass: "fa-solid fa-check text-gray-400"
  }) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "flex justify-between space-x-1 text-gray-400 cursor-not-allowed items-center hover:bg-gray-100 px-2.5 py-1 rounded-md"
  }, [_c('span', [_vm._v("Selection")]), _vm._v(" "), (_vm.revise.mode === 'Selection') ? _c('i', {
    staticClass: "fa-solid fa-check text-gray-400"
  }) : _vm._e()])])]), _vm._v(" "), _c('button', {
    staticClass: "text-white w-8 h-6 rounded-lg flex justify-center items-center disabled:opacity-50 bg-pinky hover:bg-pinky-dark cursor-pointer",
    attrs: {
      "disabled": _vm.revise.input === '' || _vm.revise.input.length < 4 ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.handleReviseWrittenPrompt()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-arrow-right-long"
  })])], 1)]), _vm._v(" "), (_vm.isRevising === true) ? _c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "h-0.5 w-full bg-pink-100 overflow-hidden"
  }, [_c('div', {
    staticClass: "progress w-full h-full bg-pink-500 left-right"
  })])]) : _vm._e()]), _vm._v(" "), (_vm.isLoading === false && _vm.roundtable) ? _c('div', {
    staticClass: "w-full h-full flex-grow"
  }, [_c('Editor', {
    ref: "editorWrittenPrompt",
    attrs: {
      "init": _vm.editor,
      "api-key": "no-api-key"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1) : _c('div', {
    staticClass: "w-full h-full flex-grow"
  }, [_c('div', {
    staticClass: "space-y-2.5 animate-pulse w-full px-16 py-14",
    attrs: {
      "role": "status"
    }
  }, [_c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-32"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-24"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-24"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-24"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-32"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-24"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-full"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-32"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-24"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-24"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-24"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-32"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-24"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-full"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center w-full space-x-2"
  }, [_c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3 bg-gray-300 rounded-full dark:bg-gray-600 w-full"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-61da983c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/WrittenRoundtables/Dialogs/EditWrittenRoundTable.vue
// module id = 949
// module chunks = 61